<!-- Компактный показатель в сводной строке ПЛАНа или ФАКТа. -->
<template>
  <span class="summary-metric">
    <span>{{ label }}</span>
    <strong>{{ value }}</strong>
  </span>
</template>

<script>
export default {
  name: "OrderPlanCalculationSummaryMetric",

  props: {
    label: { type: String, required: true },
    value: { type: String, default: "—" },
  },
};
</script>

<style scoped>
.summary-metric {
  display: flex;
  flex: none;
  flex-direction: column;
  gap: 1px;
}

.summary-metric > span {
  color: #5b6070;
  font-size: 11px;
}

.summary-metric > strong {
  font-size: 14px;
  font-weight: 600;
}
</style>
